/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnergyPriceRefreshRequest } from '../../models/energy-price-refresh-request';
import { EnergyPriceRefreshResponse } from '../../models/energy-price-refresh-response';

export interface RefreshEnergyPrices$Params {
  
    /**
     * Delivery days to poll
     */
    body: EnergyPriceRefreshRequest
}

export function refreshEnergyPrices(http: HttpClient, rootUrl: string, params: RefreshEnergyPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<EnergyPriceRefreshResponse>> {
  const rb = new RequestBuilder(rootUrl, refreshEnergyPrices.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnergyPriceRefreshResponse>;
    })
  );
}

refreshEnergyPrices.PATH = '/admin/energy-prices/refresh';
